import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import { VscGithubAlt } from "react-icons/vsc";

const projects = [
    {
        id: 1,
        name: "Pinterest Clone",
        description: "A web app that lets users create, save, and organize image collections similar to Pinterest.",
        date: "April 2024",
        image: 'assets/Pinterest.png',
        github: 'https://github.com/Kmlvaa/Pinterest_React.git',
        techs: [
            { id: 1, name: 'React' },
            { id: 3, name: '.NET' },
            { id: 4, name: 'SQL Server' },
        ]
    },
    {
        id: 2,
        name: "X academy",
        description: "An educational platform offering professional courses with a modern and responsive interface.",
        date: "Oct 2024",
        image: 'assets/XAcademy.png',
        github: 'https://github.com/Kmlvaa/XAcademy.git',
        techs: [
            { id: 1, name: 'React' },
            { id: 2, name: 'Tailwind CSS' },
            { id: 3, name: 'Ant Design' },
        ]
    },
    {
        id: 3,
        name: "Aladdin Agency",
        description: "A dynamic website presenting an agency’s branding, design, and digital marketing services.",
        date: "Oct 2024 - Dec 2024",
        image: 'assets/Agency.png',
        github: 'https://github.com/Kmlvaa/Agency.git',
        techs: [
            { id: 1, name: 'React' },
            { id: 2, name: 'Tailwind CSS' },
            { id: 4, name: 'Ant Design' },
        ]
    },
    {
        id: 4,
        name: "Admin Panel",
        description: "A functional dashboard project featuring analytics, data tables, and interactive management tools.",
        date: "Dec 2024 - Jan 2025",
        image: 'assets/adminpanel.png',
        github: 'https://github.com/Kmlvaa/AdminPanel.git',
        techs: [
            { id: 1, name: 'React' },
            { id: 2, name: 'Tailwind CSS' },
        ]
    },
    {
        id: 5,
        name: "Portfolio",
        description: "A personal website showcasing projects, design sense, and development skills.",
        image: 'assets/portfolio.png',
        github: 'https://github.com/Kmlvaa/InternIntelligence_portfolio.git',
        techs: [
            { id: 1, name: 'React' },
            { id: 2, name: 'Tailwind CSS' },
        ]
    },
    {
        id: 6,
        name: "MovieWatch",
        description: "A platform for discovering and exploring movies, TV shows, and anime worldwide.",
        date: "Mart 2025",
        image: 'assets/movieWatch.png',
        github: 'https://github.com/Kmlvaa/InternIntelligence_MovieWatch.git',
        techs: [
            { id: 1, name: 'React' },
            { id: 2, name: 'Tailwind CSS' },
            { id: 3, name: 'API integration' },
        ]
    }
]

export default function Projects() {
    useEffect(() => {
        AOS.init({ duration: 800, once: false });
    }, []);
    return (
        <div className=' w-full h-auto text-customPurple px-20 py-28 max-lg:px-10'>
            <h1 data-aos='zoom-in-down' className='text-5xl font-bold text-lightPurple mb-20 w-40 m-auto max-sm:w-32 max-sm:text-4xl'>Projects</h1>
            <div className='grid grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 gap-10 w-full max-lg:gap-14'>
                {projects?.map((project) => (
                    <div data-aos='fade-up-right' key={project.id} className="flex flex-col border-2 border-gray-100 shadow-lightPurple rounded-2xl hover:border-purple-200 group"
                        style={{ boxShadow: "0 4px 8px rgba(168, 85, 247, 0.35)" }}>
                        <div data-aos='zoom-in-left' className='rounded-t-2xl w-full h-48 hover:shadow-[0px_8px_8px_-8px_#e8e8e8] overflow-hidden'>
                            <img src={project.image} alt={project.name} className='cover w-full h-full rounded-t-2xl group-hover:scale-110 transition-transform duration-500' />
                        </div>
                        <div className='w-auto h-auto m-5 flex flex-col gap-5'>
                            <h1 className='text-lightPurple font-semibold text-3xl'>{project.name}</h1>
                            <p className='text-gray-600'>{project.description}</p>
                            <div className='flex flex-row flex-wrap gap-3'>
                                {project.techs?.map((tech) => (
                                    <div key={tech.id} className='px-3 py-1 text-lightPurple border border-lightPurple bg-purple-50 rounded-2xl text-center'>{tech.name}</div>
                                ))}
                            </div>
                            <div className='w-20 flex flex-row items-center justify-start text-lightPurple hover:text-customPurple'>
                                <a href={project.github} target='_blank' rel="noopener noreferrer" aria-label={`${project.name}`}
                                    className='cursor-pointer w-5'>
                                    <VscGithubAlt size={16} />
                                </a>
                                <a href={project.github} target='_blank' rel="noopener noreferrer" aria-label={`${project.name}`}
                                    className='cursor-pointer w-6'>
                                    <span className='cursor-pointer'>Code</span>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

